<template>
  <div class="testPaperManage" v-loading="loading">
    <!-- <el-button size="small" type="primary" @click="addExam()" class="testPaperManage-button">添加自定义试卷</el-button> -->
    <div v-for="(item,index) in examList" :key="index">
      <div class="testPaperManage-title">
        <div
          style="font-size:16px"
          v-if="item.iconPlus==false"
          class="el-icon-circle-plus-outline"
          @click="iconPlusClick(item,1)"
        ></div>
        <div
          style="font-size:16px"
          v-if="item.iconPlus==true"
          class="el-icon-remove-outline"
          @click="iconPlusClick(item,2)"
        ></div>
        {{item.name}}
      </div>
      <div v-if="item.iconPlus==true" class="testPaperManage-box01">
        <div class="testPaperManage-box02" v-for="(items,indexs) in item.children" :key="indexs">
          <div class="testPaperManage-subject01">{{items.name}}</div>
          <div
            class="testPaperManage-subject02"
            v-for="(itemss,indexss) in items.children"
            :key="indexss"
            @click="goTestPaperManageDetail(itemss.id)"
          >{{itemss.name}}（{{itemss.number}}）</div>
        </div>
      </div>
    </div>
    <div v-if="examList.length==0" class="testPaperManageDetail-none">
      <div>暂无默认试卷，请先进入试卷管理添加模拟考卷</div>
      <div class="testPaperManageDetail-button" @click="goExam">点击进入试卷管理</div>
      </div>
    <el-dialog
      title="添加试卷"
      :visible.sync="addFormVisible"
      width="25%"
      :close-on-click-modal="false"
      left
    >
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
        <el-form-item label="所属课程" prop="courseId">
          <el-cascader
            clearable
            style="width:100%"
            v-model="addForm.courseId"
            :show-all-levels="false"
            :props="subjectTreeProp"
            placeholder="请选择所属课程"
            :options="subjectTreeList"
            @change="subjectChangePageList(addForm.courseId)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="考试名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入考试名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="评分标准" prop="scoreRuleId">
          <el-select
            style="width:100%"
            v-model="addForm.scoreRuleId"
            clearable
            placeholder="请输入评分标准"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addExamSetting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children"
      },
      examList: [1],
      addForm: {
        type: "全真模考"
      },
      subjectTreeList: [],
      optionsType: [],
      addFormVisible: false,
      loading: true,
      rules: {
        courseId: [
          {
            required: true,
            message: "请选择所属课程",
            trigger: "change"
          }
        ],
        scoreRuleId: [
          {
            required: true,
            message: "请选择评分标准",
            trigger: "change"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "评分标准格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "考试名称长度在1到255个字"
          }
        ]
      }
    };
  },
  methods: {
    // 获取课程
    // getSubjectTreeList() {
    //   this.api
    //     .getSubjectCourseTreeList()
    //     .then(result => {
    //       for(let index in result.data){
    //           if(index == 0){
    //             result.data[index].iconPlus = true
    //           }else{
    //             result.data[index].iconPlus = false
    //           }
    //         }
    //       this.examList = result.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    addExam() {
      this.addFormVisible = true;
      this.getSubjectTreeList();
      // this.getScoreRuleSelectListByCourse();
    },
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    subjectChangePageList() {
      this.api.scoreRule
        .getScoreRuleSelectListByCourse({
          courseId: this.addForm.courseId[2]
        })
        .then(result => {
          this.optionsType = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addExamSetting() {
      this.addForm.courseId = this.addForm.courseId[2];
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.examSetting.addExam(this.addForm).then(result => {
            this.getSubjectCourseExamCount();
            this.addFormVisible = false;
          });
        }
      });
    },
    getSubjectCourseExamCount() {
      this.$nextTick(() => {
        this.api.examSetting
          .getExamCount()
          .then(result => {
            if (result.success) {
              for (let index in result.data) {
                if (index == 0) {
                  result.data[index].iconPlus = true;
                } else {
                  result.data[index].iconPlus = false;
                }
              }
              this.examList = result.data;
              this.loading = false;
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    iconPlusClick(item, row) {
      if (row == 1) {
        item.iconPlus = true;
      }
      if (row == 2) {
        item.iconPlus = false;
      }
    },
    goTestPaperManageDetail(courseId) {
      let obj = { courseId: courseId };
      localStorage.setItem("jumpDetail", JSON.stringify(obj));
      this.$router.push({ path: "/testPaperManageDetail" });
    },
    goExam(){
      this.$router.push({ path: "/exam" });
    },
  },
  watch: {},
  mounted() {
    this.getSubjectCourseExamCount();
  }
};
</script>
<style scoped>
.testPaperManage {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  background-color: #fff;
  min-height: calc(100% - 20px);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.testPaperManage-button {
  float: right;
  margin-top: 20px;
}
.testPaperManageDetail-none {
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 45%;
}
.testPaperManage-title {
  padding-top: 20px;
  font-size: 16px;
}
.testPaperManage-box01 {
  display: flex;
  flex-wrap: wrap;
}
.testPaperManage-box02 {
  background-color: #f6f9fa;
  width: 220px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
  margin-right: 20px;
  text-align: center;
  height: 100%;
}
.testPaperManage-subject01 {
  margin-top: 10px;
  color: #455a64;
  font-size: 14px;
}
.testPaperManage-subject02 {
  color: #4d94ff;
  font-size: 13px;
  height: 30px;
  line-height: 32px;
  margin-top: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  cursor: pointer;
}
.testPaperManageDetail-button{
  color: #4d94ff;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/fullTruthModelTest/testPaperManage.vue